
import { Component,  Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component
export default class EntitySocialMethods extends Vue {
    public showMessageActions: boolean = false;
    public activeMessage: any = null;

    public openMessageActions(message: any) {
        this.activeMessage = message;
        this.showMessageActions = true;
    }

    public closeMessageActions() {
        this.activeMessage = null;
        this.showMessageActions = false;
    }

    public deleteMessage() {
        this.$store.dispatch(Actions.REMOVE_COMMENT, this.activeMessage)
            .then(() => {
                this.closeMessageActions();
                this.configureCommentsTabTitle();
            });
    }

    public configureCommentsTabTitle() {}

    public showComments(entity: string, entityId: number) {
        this.$store.commit(Mutations.SET_COMMENTS_OVERLAY_VISIBILITY, true);

        switch (entity) {
            case 'notification':
                this.$store.dispatch(Actions.FETCH_NOTIFICATION_COMMENTS, {vue: this, notificationId: entityId});
                break;
        }
    }
}
